import { httpPost, httpPatchMerge, httpDelete } from './http'
import type { TEntityId } from '~/types/models'
import type { ICompanyMSContact } from '~/types/company/models'

const apiEntityPath = '/api/companymscontacts'

export async function createCompanyMSContact(entity: ICompanyMSContact) {
  const callingMn = createCompanyMSContact.name
  const apiPath = apiEntityPath
  return httpPost<ICompanyMSContact>({
    callingMn,
    apiPath,
    entity,
  })
}

export async function updateCompanyMSContact(
  entityData: Partial<ICompanyMSContact>,
  id: TEntityId
) {
  const callingMn = updateCompanyMSContact.name
  const apiPath = `${apiEntityPath}/${id}`
  type TPartialCompanyMSContact = Partial<ICompanyMSContact>
  return httpPatchMerge<TPartialCompanyMSContact>({
    callingMn,
    apiPath,
    entityData,
  })
}

export async function deleteCompanyMSContact(entityData: ICompanyMSContact) {
  const callingMn = deleteCompanyMSContact.name
  const apiPath = apiEntityPath
  return httpDelete<ICompanyMSContact>({
    callingMn,
    apiPath,
    entityData,
  })
}
